import apiURl from '../constant/urls.js';
import {GET_USER_DATA,GET_COURSE_DATA} from '../constant/urls.js';

export const GetUserDataByTenantID = async (userData) => {
    var token = localStorage.getItem('userToken');
    const apiCall = await fetch(`${apiURl}${GET_USER_DATA}`,{
        method:'POST',
        headers:{
            'Content-Type':'application/json',
            'Authorization':`Bearer ${token}`
        },
        body:JSON.stringify(userData)
    });
    const response = await apiCall.json();
    return response;    
};
export const GetCourseDataByTenantID = async (courseData) => {
    var token = localStorage.getItem('userToken');
    const apiCall = await fetch(`${apiURl}${GET_COURSE_DATA}`,{
        method:'POST',
        headers:{
            'Content-Type':'application/json',
            'Authorization':`Bearer ${token}`
        },
        body:JSON.stringify(courseData)
    });
    const response = await apiCall.json();
    return response;    
}